import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AlertModule } from 'ngx-bootstrap';
import { NoAuthGuard } from '@ecosure-suite/shared/utils-helpers';
import { BackOfficeAuthDataAccessAuthModule } from '@ecosure-suite/back-office/auth/data-access-auth';
import { CommonSharedModule } from '@ecosure-suite/common/shared';
import { LoginCoreComponent } from './containers';
import { LoginComponent } from './components';

export const backOfficeAuthFeatureShellRoutes: Route[] = [
  {
    path: '',
    component: LoginCoreComponent,
    canActivate: [NoAuthGuard],
    data: {
      title: 'Login Page'
    }
  }
];

@NgModule({
  imports: [
    AlertModule,
    BackOfficeAuthDataAccessAuthModule,
    CommonModule,
    CommonSharedModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule.forChild()
  ],
  declarations: [LoginCoreComponent, LoginComponent]
})
export class BackOfficeAuthFeatureShellModule {}
